
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";

const Login = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const checkSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          navigate("/admin");
        }
        setIsChecking(false);
      } catch (error) {
        console.error("Session check error:", error);
        setIsChecking(false);
      }
    };
    
    checkSession();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN") {
        toast({
          title: "ログイン成功",
          description: "ようこそ！",
        });
        navigate("/admin");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate, toast]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-foreground">確認中...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 pt-16">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-primary">管理者ログイン</h2>
          <p className="mt-2 text-muted-foreground">アカウントにサインインして続行</p>
        </div>
        <div className="bg-card p-8 rounded-lg shadow-lg border border-border">
          <Auth
            supabaseClient={supabase}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: '#8B5CF6', // より鮮やかな紫色
                    brandAccent: '#7E69AB', // ホバー時の色
                    inputText: 'hsl(var(--foreground))',
                    inputLabelText: 'hsl(var(--foreground))',
                    inputPlaceholder: 'hsl(var(--muted-foreground))',
                  },
                },
              },
              className: {
                input: 'text-foreground',
                label: 'text-foreground',
                button: 'text-white',
                anchor: 'text-primary hover:text-primary/80',
              },
            }}
            localization={{
              variables: {
                sign_in: {
                  email_label: 'メールアドレス',
                  password_label: 'パスワード',
                  button_label: 'ログイン',
                  loading_button_label: '処理中...',
                  link_text: 'アカウントをお持ちでない方はこちら',
                },
                sign_up: {
                  email_label: 'メールアドレス',
                  password_label: 'パスワード',
                  button_label: '登録',
                  loading_button_label: '処理中...',
                  link_text: '既にアカウントをお持ちの方はこちら',
                },
              },
            }}
            providers={[]}
            redirectTo={window.location.origin + '/admin'}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
